<template>
  <footer class="flex w-full justify-center bg-slate-800 px-5 py-[30px] lg:py-10">
    <div class="relative flex w-full flex-col items-start lg:w-[1060px]">
      <img class="h-[34px]" :src="localeLogoImg" alt="logo" loading="lazy" />
      <div class="flex w-full flex-col justify-between pt-4 text-xs leading-tight text-slate-700 sm:flex-row">
        <div
          class="flex flex-col self-stretch whitespace-pre-line text-[13px] font-normal leading-normal text-slate-300"
        >
          {{ $t('footer.companyInfo') }}
          <span class="pt-2.5">Copyright ⓒ Guardiann. All rights reserved.</span>
        </div>
      </div>

      <div
        class="flex gap-3 pt-[20px] font-bold leading-none text-slate-300 lg:absolute lg:right-0 lg:gap-[30px] lg:pt-0"
      >
        <button
          class="text-xs underline underline-offset-4 lg:text-sm"
          @click="navigateTo(localeRoute('/policy/terms'))"
        >
          {{ $t('footer.terms') }}
        </button>

        <button
          class="text-xs underline underline-offset-4 lg:text-sm"
          @click="navigateTo(localeRoute('/policy/privacy'))"
        >
          {{ $t('footer.privacy') }}
        </button>

        <button
          v-if="locale === 'ko'"
          class="text-xs underline underline-offset-4 lg:text-sm"
          @click="navigateTo(localeRoute('/policy/location'))"
        >
          {{ $t('policy.location') }}
        </button>
      </div>

      <div class="inline-flex items-center gap-[5px] pt-[20px] lg:absolute lg:bottom-0 lg:right-0">
        <EnvelopeIcon class="mt-1 size-3.5 text-slate-300" />
        <div class="text-[15px] font-bold text-slate-300 underline underline-offset-[5px]">guardiann@8snippet.com</div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import {EnvelopeIcon} from '@heroicons/vue/20/solid'
import Logo_ko from '~/assets/svg/8snippet_logo.svg'
import Logo_en from '~/assets/svg/8snippet_logo_en.svg'
const localeRoute = useLocaleRoute()
const {locale} = useI18n()

const localeLogoImg = computed(() => {
  return locale.value === 'ko' ? Logo_ko : Logo_en
})
</script>

<style lang="scss" scoped></style>
